module.exports = __webpack_public_path__ + "img/SES_202281255.0d9f27a9.jpg";